import { Dispatch, SetStateAction } from "react";
import CustomLabel from "../../common/CustomLabel";
import { FilterCriteria } from "../../../types";
import CustomAccordion from "../../common/CustomAccordion";

const ReportEventConcernTypeFilter = ({
  filterCriteria,
  setFilterCriteria,
}: {
  filterCriteria: FilterCriteria;
  setFilterCriteria: Dispatch<SetStateAction<FilterCriteria>>;
}) => {
  return (
    <CustomAccordion label="Event/Concern Type" defaultOpen={true}>
      <div className="flex flex-col gap-4">
        <CustomLabel
          labelText="Case Type:"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            placeholder="Select case type"
            className="font-medium text-[14px] leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.caseType || ""}
            onChange={(e) =>
              setFilterCriteria((prev) => ({
                ...prev,
                caseType: e.target.value,
              }))
            }
          />
        </CustomLabel>

        <CustomLabel
          labelText="Subcase Type:"
          labelTextClass="px-4"
          labelWrapClass="!gap-1"
        >
          <input
            type="text"
            placeholder="Select case type"
            className="font-medium text-sm leading-4 text-gray-7 w-full border border-gray-3 rounded-3xl py-4 px-4 outline-none focus:ring-1 focus:ring-black focus:border-transparent cursor-pointer"
            value={filterCriteria.subCaseType || ""}
            onChange={(e) =>
              setFilterCriteria((prev) => ({
                ...prev,
                subCaseType: e.target.value,
              }))
            }
          />
        </CustomLabel>
      </div>
    </CustomAccordion>
  );
};

export default ReportEventConcernTypeFilter;
